import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[70vh] md:min-h-[90vh] flex flex-col items-center justify-center px-6 py-12 md:py-20 overflow-hidden" data-id="element-53">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none" data-id="element-54">
        <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-olive-100/50 to-transparent" data-id="element-55" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-400/10 rounded-full blur-3xl" data-id="element-56" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-57">
        <FadeIn delay={0.1} direction="down" data-id="element-58">
          <span className="inline-block mb-4 md:mb-6 text-sm font-medium tracking-[0.2em] text-gold-600 uppercase" data-id="element-59">
            Blue Zone Longevity Mindset Guide
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-60">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-olive-900 leading-[1.1] mb-4 md:mb-6 text-balance" data-id="element-61">
            The Secret to 100 Isn't Just What They Eat—
            <span className="italic text-medBlue-700" data-id="element-62">
              It's How They Think.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-63">
          <div className="max-w-xs mx-auto mb-8 rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20" data-id="element-64">
            <video src="https://cdn.magicpatterns.com/uploads/rPsSxJ76NC8uqHeCxwxaPK/BZ - VSL2.mp4" controls controlsList="nodownload" autoPlay muted playsInline className="w-full aspect-[9/16] object-cover" poster="https://cdn.magicpatterns.com/uploads/iw1WhFWzJeqUa7Wq3RRexk/BZ-mockup2.png" data-id="element-65">
              <track kind="subtitles" srcLang="es" label="Español" data-id="element-66" />
            </video>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-67">
          <p className="text-lg md:text-xl text-stone-600 max-w-2xl mx-auto mb-8 md:mb-12 font-light leading-relaxed" data-id="element-68">
            Discover the ancient mindset frameworks behind the world's
            longest-lived people.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="relative mb-8 md:mb-12 group" data-id="element-69">
          <div className="absolute inset-0 bg-gold-500/20 blur-2xl rounded-full transform scale-75 group-hover:scale-90 transition-transform duration-700 opacity-0 group-hover:opacity-100" data-id="element-70" />
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.5,
          ease: 'easeOut'
        }} className="relative" data-id="element-71"></motion.div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-72">
          <Button size="lg" icon scrollToOffer data-id="element-73">
            Start Your Journey
          </Button>
          <p className="mt-4 text-sm text-stone-500" data-id="element-74">
            Instant Digital Download • $6.39
          </p>
        </FadeIn>
      </div>
    </section>;
}